import axios from "axios";
import { SOLANA_DECIMAL } from "../config";

// const apiUrl = "http://192.168.79.131:3000"; // dev url
// const apiUrl = "http://127.0.0.1:9000"; // local dev url
const apiUrl = "https://sei.texaglo.com";
const nutUrl = "https://api.snowonsol.com";

export const getAllListedNfts = async () => {
  try {
    const response = await axios.get(`${nutUrl}/listednfts/`);
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting listednfts:", error);
      throw error;
    }
  }
};

export const saveListedNftData = async (listData, transactions) => {
  try {
    const response = await axios.post(`${nutUrl}/listednfts/create`, {
      listData,
      transactions,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save listed nft data.", error);
      throw error;
    }
  }
};

export const saveDelistedNftData = async (mintAddrArray, transactions) => {
  try {
    const response = await axios.post(`${nutUrl}/listednfts/`, {
      mintAddrArray,
      transactions,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save delisted nft data.", error);
      throw error;
    }
  }
};

export const updatePrice = async (transaction, solPrice, mintAddr) => {
  try {
    const response = await axios.put(`${nutUrl}/listednfts/`, {
      transaction,
      solPrice,
      mintAddr,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const saveMadeOfferData = async (transaction, offerData) => {
  try {
    const response = await axios.post(`${nutUrl}/offer/create`, {
      transaction,
      offerData,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const saveCancelMadeOfferData = async (transaction, mintAddr, buyer) => {
  try {
    const response = await axios.post(`${nutUrl}/offer/canceloffer`, {
      transaction,
      mintAddr,
      buyer,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const savePurchasedData = async (
  transaction,
  purchaseData,
  mintAddrArray
) => {
  try {
    const response = await axios.post(`${nutUrl}/listednfts/purchase`, {
      transaction,
      purchaseData,
      mintAddrArray,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const saveCreateAuctiondata = async (transaction, auctionData) => {
  try {
    const response = await axios.post(`${nutUrl}/auction/create`, {
      transaction,
      auctionData,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const cancelAuctionData = async (transaction, mintAddr) => {
  try {
    const response = await axios.post(`${nutUrl}/auction/cancel`, {
      transaction,
      mintAddr,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};

export const saveAcceptOfferData = async (mintAddr, buyer, seller, transaction) => {
  console.log("mintAddr", mintAddr)
  console.log("buyer", buyer)
  console.log("seller", seller)
  console.log("transaction", transaction)
  try {
    const response = await axios.post(`${nutUrl}/offer/acceptoffer`, {
      mintAddr,
      buyer,
      seller,
      transaction,
    });
    return response;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error Save update nft price.", error);
      throw error;
    }
  }
};




export const getActivityBySeller = async (seller) => {
  try {
    const response = await axios.get(
      `${nutUrl}/activity/findById/${seller}`,
      {}
    );
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting listednfts:", error);
      throw error;
    }
  }
};

export const getActivityAll = async (seller) => {
  try {
    const response = await axios.get(`${nutUrl}/activity/findAll/`, {});
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting listednfts:", error);
      throw error;
    }
  }
};

export const getAllCollection = async () => {
  try {
    const response = await axios.get(`${nutUrl}/collection/findAll/`, {});
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting collection data:", error);
      throw error;
    }
  }
};

export const getAllOfferMintAddr = async (mintAddr) => {
  try {
    const response = await axios.get(
      `${nutUrl}/offer/findAllByMintAddr/${mintAddr}`
    );
    console.log("response.data", response.data)
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting collection data:", error);
      throw error;
    }
  }
};

export const getAllOfferByBuyer = async (buyer) => {
  try {
    const response = await axios.get(
      `${nutUrl}/offer/findAllByBuyer/${buyer}`
    );
    console.log("buyer", response.data)
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting collection data:", error);
      throw error;
    }
  }
}


export const getAllAuctionBySeller = async (seller) => {
  try {
    const response = await axios.get(
      `${nutUrl}/auction/findAllBySeller/${seller}`
    );
    return response.data;
  } catch (error) {
    if ((error.request = 404)) {
      return 0;
    } else {
      console.error("Error getting collection data:", error);
      throw error;
    }
  }
};
